"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBreakpoint = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var getBreakpoint = function getBreakpoint(width, breakpoints) {
  var breakpointsArray = Object.entries(breakpoints).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    return {
      key: key,
      val: val || 0 // hack: should never be undefined, but entire key/val is optional

    };
  });
  breakpointsArray.sort(function (a, b) {
    return a.val - b.val;
  });

  if (!breakpointsArray.length) {
    throw new Error("No breakpoints defined");
  }

  var newResponsiveKey = breakpointsArray[0].key;

  if (breakpointsArray.length === 1) {
    return newResponsiveKey;
  }

  for (var i = 0; i < breakpointsArray.length; i += 1) {
    if (width >= breakpointsArray[i].val) {
      newResponsiveKey = breakpointsArray[i].key;
    } else {
      break;
    }
  }

  return newResponsiveKey;
};

exports.getBreakpoint = getBreakpoint;